// Define constants used for layout configuration across the application
const LAYOUT_CONST = {
  // Types of layouts the app can have
  VERTICAL_LAYOUT: 'vertical', // Standard vertical layout (sidebar on the left)
  HORIZONTAL_LAYOUT: 'horizontal', // Top navigation layout

  // Types of drawer (sidebar) appearance
  DEFAULT_DRAWER: 'default', // Full-width drawer
  MINI_DRAWER: 'mini-drawer' // Collapsed / mini drawer (icons only)
};

// Export layout constants so they can be used in layout components
export default LAYOUT_CONST;
